<template>
  <div class="popup" v-cloak v-if="traverseTimeShow">
      <div class="content" id="traverseTimeRealTime">
            <div class="title">
                {{$t('language.cloudSync.timeOut')}}
                 <div class="icon white-close dialog-close" @click="traverseTimeShow=false"></div>
            </div>
            <div class="traverseTime-body">
                   <div class="traverseTime-info">
                        {{$t('language.cloudSync.outMostly')}}
                   </div>
                   <div class="realtime-traverseTime-bottom">
                        <button style="width:110Px;float:right;" @click.stop="sureTasK()"> {{$t('language.common.ok')}}</button>
                   </div>
            </div>
      </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data:function(){
        return{
            traverseTimeShow:false,
            isSure:false,
            isSelected:false,
            addData:null,
        }
    },
    methods: {
        sureTasK(){
           this.traverseTimeShow = false;
        }

    },
    
}
</script>

<style>
#traverseTimeRealTime{
    width: 560Px;
    height: 220Px;
}
.traverseTime-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 10Px;
    box-sizing: border-box;
    text-align: left;
  
}
.traverseTime-info{
    width: 100%;
    height:100Px;
    float: left;
}
.realtime-traverseTime-bottom{
    width: 528Px;
    height: 40Px;
    float: left;

}
.notraverseTimecheck-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -20px -208px;
    /*no*/
}

.check-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -88px -208px;
    /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/travese_time_popup.vue